import { render, staticRenderFns } from "./CheckoutHero.vue?vue&type=template&id=2c97c173&scoped=true"
import script from "./CheckoutHero.vue?vue&type=script&lang=js"
export * from "./CheckoutHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c97c173",
  null
  
)

export default component.exports